<p-toolbar>
      <div class="p-toolbar-group-start">
        <button
          pButton
          type="button"
          icon="pi pi-caret-left"
          class="p-button-secondary mr-2"
          *ngIf="editorMode"
        ></button>
        <button
          pButton
          type="button"
          icon="pi pi-caret-right"
          class="p-button-secondary mr-2"
          *ngIf="editorMode"
        ></button>
        <button
          pButton
          type="button"
          icon="pi pi-copy"
          class="p-button-secondary mr-2"
          *ngIf="editorMode"
        ></button>
        <button
          pButton
          type="button"
          icon="pi pi-trash"
          class="p-button-secondary mr-2"
          (click)="onDeleteItem($event)"
          *ngIf="editorMode"
        ></button>
        <button
          pButton
          type="button"
          icon="pi pi-undo"
          class="p-button-secondary mr-2"
          *ngIf="editorMode"
        ></button>
        <p-inputNumber
          [showButtons]="true"
          buttonLayout="horizontal"
          spinnerMode="horizontal"
          decrementButtonClass="p-button-secondary"
          incrementButtonClass="p-button-info"
          incrementButtonIcon="pi pi-plus"
          decrementButtonIcon="pi pi-minus"
          mode="decimal"
          class="mr-2"
          [step]="10"
          [min]="20"
          [max]="150"
          suffix="%"
          [size]="5"
          [(ngModel)]="zoomValue"
          (ngModelChange)="onZoomChange()"
        ></p-inputNumber>
        <button
          pButton
          type="button"
          icon="pi pi-save"
          class="p-button-primary mr-2"
          title="{{ 'Guardar' | translate }}"
          (click)="onSaveLayout($event)"
          *ngIf="editorMode"
          [disabled]="!(layoutUpdated | async)"
        ></button>
        <button
          pButton
          type="button"
          icon="pi pi-download"
          class="p-button-primary mr-2"
          title="{{ 'Descargar' | translate }}"
          (click)="onExportToImage($event)"
          *ngIf="!editorMode"
        ></button>
      </div>
  </p-toolbar>
  